import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "components/ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import { useGetServiceTeamQuery } from "store/apis/serviceTeam";
import { validate } from "uuid";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import { FILTER_REVIEWER, UNASSIGNED_OPTION } from "../Task1120FilterOptions";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const ReviewerColumnHeader = ({
  values,
  updateFilter,
  defaultServiceTeamId,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
  defaultServiceTeamId: string | null;
}) => {
  const selectedTeams = values.SERVICE_TEAM || null;
  const { isAdmin } = useRoleBasedView();
  const serviceTeamIds = (isAdmin ? selectedTeams : defaultServiceTeamId)
    ?.split(",")
    .filter((id) => validate(id))
    .join(",");

  const { data: teamMembers = [] } = useGetServiceTeamQuery(
    { serviceTeamId: serviceTeamIds },
    {
      skip: !serviceTeamIds,
      refetchOnMountOrArgChange: true,
    }
  );

  const updatedOptions = [
    { uuid: UNASSIGNED_OPTION, name: "Unassigned" },
    ...teamMembers,
  ];

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Reviewer</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_REVIEWER}
        options={updatedOptions.map((member) => ({
          value: member.uuid,
          label: member.name,
        }))}
        selected={values.REVIEWER || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
